import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import numeral from 'numeral'

import i18n from 'Pods/Shared/I18n'
import Tooltip from './Tooltip'
import Icon from './Icon/Icon'


class BuyerLoyaltyProgressBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      progress: 0,
      currentLevelExpenses: 0,
      nextLevelExpenses: 0,
      currentLoyaltyLevel: 0,
      nextLoyaltyLevel: 0,
      lifetimePricePaid: 0,
    }

    this.fetchUserStats = this.fetchUserStats.bind(this)
    this.onFetchUserStatsSuccess = this.onFetchUserStatsSuccess.bind(this)
  }

  componentDidMount() {
    this._isMounted = true

    this.fetchUserStats()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  fetchUserStats() {
    return axios.get('/api/internal/users/buyer-loyalty-stats').then(this.onFetchUserStatsSuccess)
      .catch((error) => {})
  }

  onFetchUserStatsSuccess(response) {
    if (this._isMounted) {
      return this.setState({
        progress: response.data.data.progress,
        currentLevelExpenses: response.data.data.currentLevelExpenses,
        nextLevelExpenses: response.data.data.nextLevelExpenses,
        currentLoyaltyLevel: response.data.data.currentLoyaltyLevel / 100,
        nextLoyaltyLevel: response.data.data.nextLoyaltyLevel / 100,
        lifetimePricePaid: response.data.data.lifetimePricePaid,
      })
    }
  }

  render() {
    const infoTooltipMessage = I18n.t(
      'tooltips.buyer_loyalty_program_html',
      {
        buyer_loyalty_rate: numeral(this.props.buyerLoyaltyLevel).format('0%'),
      }
    )

    const currentLevelTooltipMessage = I18n.t(
      'tooltips.buyer_loyalty_program_current_level_html',
      {
        total_price_paid: numeral(this.state.lifetimePricePaid).format('$0'),
        buyer_loyalty_rate: numeral(this.props.buyerLoyaltyLevel).format('0%'),
      }
    )

    const nextLevelTooltipMessage = I18n.t(
      'tooltips.buyer_loyalty_program_next_level_html',
      {
        next_lvl_expenses: numeral(this.state.nextLevelExpenses).format('$0'),
        next_lvl_expenses_rate: numeral(this.state.nextLoyaltyLevel).format('0%'),
        left_until_next_lvl: numeral(this.state.nextLevelExpenses - this.state.lifetimePricePaid).format('0'),
      }
    )

    return (
      <div className="loyalty-level-progress loyalty-level-progress--transparent has-border loyalty-level-progress--small">
        <div className="loyalty-level-progress__title">
          {i18n.t('navigation.credits_user_widget.earn_rate', { ns: 'rails', lng: this.props.locale })}
          {numeral(this.props.buyerLoyaltyLevel).format('0%')}
          <Tooltip
            id="creditEarnRateInfo"
            className="u-ml10"
            tooltipClassName="tooltip--small"
            content={infoTooltipMessage}
            html
          >
            <Icon type="question-circle" color="primary" notSpaced />
          </Tooltip>
        </div>
        <div className="loyalty-level-progress__progress">
          <Tooltip
            id="lifetimePricePaid"
            className="current-lvl-expenses"
            tooltipClassName="tooltip--small"
            content={currentLevelTooltipMessage}
            html
          >
            {i18n.t('navigation.credits_user_widget.lifetime_spending', { ns: 'rails', lng: this.props.locale })}
            {numeral(this.state.lifetimePricePaid).format('$0')}
          </Tooltip>
          <Tooltip
            id="nextLevelExpenses"
            className="next-lvl-expenses u-float-right"
            tooltipClassName="tooltip--small"
            content={nextLevelTooltipMessage}
            html
          >
            {i18n.t('navigation.credits_user_widget.next_level', { ns: 'rails', lng: this.props.locale })}
            {numeral(this.state.nextLevelExpenses).format('$0')}
          </Tooltip>
          <span className="progress-bar">
            <Tooltip
              id="progress"
              className="progress-bar__progress"
              tooltipClassName="tooltip--small"
              style={{ width: `${this.state.progress}%` }}
              content={currentLevelTooltipMessage}
              html
            />
            <Tooltip
              id="remainder"
              className="progress-bar__remainder"
              tooltipClassName="tooltip--small"
              style={{ width: `${100 - this.state.progress}%` }}
              content={nextLevelTooltipMessage}
              html
            />
          </span>
          <Tooltip
            id="currentLoyaltyLevel"
            className="current-loyalty-level"
            tooltipClassName="tooltip--small"
            content={currentLevelTooltipMessage}
            html
          >
            {numeral(this.state.currentLoyaltyLevel).format('0%')}
          </Tooltip>
          <Tooltip
            id="nextLoyaltyLevel"
            className="next-loyalty-level u-float-right"
            tooltipClassName="tooltip--small"
            content={nextLevelTooltipMessage}
            html
          >
            {numeral(this.state.nextLoyaltyLevel).format('0%')}
          </Tooltip>
        </div>
      </div>
    )
  }
}

BuyerLoyaltyProgressBar.propTypes = {
  buyerLoyaltyLevel: PropTypes.number.isRequired,
}

export default BuyerLoyaltyProgressBar
